import MobileMenu from './mobile-menu';
import Header from './header';
import { Fragment, useContext } from 'react';
import Product from './product';
import NewIekSidebarFixed from './sidebar-fixed';
import NewIekSidebar from './sidebar';
import Page from '../../page';
import { CategoriesContext } from '../../../App';
import { TemplateProps } from '../index';
import NewIekHome from './home';
import NewIekSearch from './search';
import NewIekNotFound from './not-found';
import NewIekCategoryOuter from './category-outer';
import NewIekCategoryInner from './category-inner';
import NewIekCatalogWrapper from './catalog-wrapper';
import './styles.scss';

function NewIek({ hasPendingRequests}: TemplateProps) {
    const { isProduct } = useContext(CategoriesContext);

    return (
        <main className={'new-iek-catalog main catalog-main' + (isProduct ? ' main--product' : '')}>
            <div className="preloader" style={{ display: hasPendingRequests ? 'block' : 'none' }}>
                <span className="spinner" />
            </div>
            <MobileMenu />
            <Header />
            {isProduct ? (
                <Fragment>
                    <Product />
                    <NewIekSidebarFixed />
                </Fragment>
            ) : (
                <section className="catalog">
                    <div className="wrap">
                        <div className="catalog__container">
                            <NewIekSidebar />
                            <Page
                                home={NewIekHome}
                                search={NewIekSearch}
                                categoryOuter={NewIekCategoryOuter}
                                categoryInner={NewIekCategoryInner}
                                catalog={NewIekCatalogWrapper}
                                notFound={NewIekNotFound}
                            />
                        </div>
                    </div>
                </section>
            )}
        </main>
    );
}

export default NewIek;
